export default __webpack_public_path__ + "static/media/black-parking-concert-tickets.3ddebc20.png";